import Drag from './drag'

export default class HotspotDrag extends Drag {
  useType = 'make';
  rightKeyMenu = null;
  blockInfo = {
    uuid: '',
    x: 40,
    y: 40,
    width: 40,
    height: 40,
    rightBottomCoordinate: {
      x: 80,
      y: 80
    },
    mislead: false, //  true: 正确答案， false: 错误答案
    blockType: 'square', // circle: 圆形， (null | square): 方形
    style: ''
  };

  /**
   * 
   *   @param {String} plate: 区域類名(.question-design) || body
   *   @param {String} useType: 使用類型。 value: ['make', 'view']. 默认 ‘make’
   *   @param {Object} blockStyle 
   *    style: 方块样式,
   *    selectStyle: 方块选中样式
   *   @param {number | string} maxNum: 允许最多方块 默认10
   */
  constructor(obj) {
    super(obj)

    this.useType = obj.useType || this.useType
    
    this.init()
  }

  init() {
    this.customRightKeyMenu()
    
    // 只有make 才能调用
    this.useType == 'make' && this.findscroller()
  }

  // 调用基類 创建方块
  handleCreateBlock(blockType = '', blockStyle = {}, info = null) {
    this.createBlock(node => {
      this.rightKeyEvent(node)
    }, blockType, blockStyle, info)
  }

  /**
   * 绑定右键事件
   * @param {*} node 
   *    绑定事件的节点
   */
  rightKeyEvent(node) {
    node.addEventListener('contextmenu', ev => {
      ev.preventDefault()

      let { rightKeyMenu, curBlock } = this
      rightKeyMenu.style.display = 'block'
      rightKeyMenu.style.left = `${ev.pageX}px`
      rightKeyMenu.style.top = `${ev.pageY}px`
      rightKeyMenu.focus()
      
      for(let i = 0; i < rightKeyMenu.childNodes.length; i++) {
        let item = rightKeyMenu.childNodes[i]

        if([...item.classList].indexOf('mislead-choice') > -1) {
          item.innerText = curBlock.mislead ? '設為錯誤答案' : '設為正確答案';
          break ;
        }
      }
    })
  }

  /**
   * 右键自定义菜单
   */
  customRightKeyMenu() {
    let menu = document.createElement('div')
    menu.setAttribute('class', 'right-key-menu')
    menu.setAttribute('tabindex', '0')
    let singleMenu = [
      {text: '設為正確答案', class: 'mislead-choice'},
      {text: '複製', class: 'copy-block'},
      {text: '刪除', class: 'remove-block'},
    ]

    // 追加子节点
    while(menu.childNodes.length < singleMenu.length) {
      let child = document.createElement('div'),
      item = singleMenu[menu.childNodes.length]
      child.setAttribute('class', `menu-single ${item.class}`)
      child.innerText = item.text

      // 每个按钮增加事件
      if(menu.childNodes.length == 0) child.addEventListener('click', misleadChoice)
      else if(menu.childNodes.length == 1) child.addEventListener('click', copyBlock)
      else if(menu.childNodes.length == 2) child.addEventListener('click', removeBlock)

      menu.append(child)
    }

    menu.style.display = 'none'
    document.body.append(menu)
    this.rightKeyMenu = menu

    // 添加失去焦点事件
    menu.addEventListener('blur', () => {
      menu.style.display = 'none'
    })

    //  -------- 子节点事件函數 --------
    let that = this

    // 误导选项
    function misleadChoice () {
      let { curBlock } = that,
      node = document.querySelector(`#${curBlock.uuid}`)
      curBlock.mislead = !curBlock.mislead

      // 添加，移除样式
      if(curBlock.mislead) node.classList.add('correct')
      else node.classList.remove('correct')

      that.rightKeyMenu.blur()
      that.fn(that.blockMap)
    }

    // 复制方块
    function copyBlock() {
      let { curBlock } = that,
      // 偏移量
      offset = 40,
      copyBlockInfo = JSON.parse(JSON.stringify(curBlock))
      copyBlockInfo.x += offset
      copyBlockInfo.y += offset
      copyBlockInfo.rightBottomCoordinate.x += offset
      copyBlockInfo.rightBottomCoordinate.y += offset

      console.log(curBlock)
      that.handleCreateBlock(copyBlockInfo.blockType, copyBlockInfo.style, copyBlockInfo)
      
      let node = document.querySelector(`#${that.curBlock.uuid}`)
      if(copyBlockInfo.mislead) {
        node.classList.add('correct')
      }
      console.log(node)

      that.rightKeyMenu.blur()
      that.fn(that.blockMap)
    }

    // 移除方块
    function removeBlock() {
      let { uuid } = that.curBlock,
      { plate } = that,
      removeNode = document.querySelector(`#${uuid}`)

      plate.removeChild(removeNode)
      that.blockMap.delete(uuid)
      that.curBlock = {}
      that.rightKeyMenu.blur()

      that.fn(that.blockMap)
    }
  }

  /**
   * 调用基類 回显视图
   * @param {Array} map 
   */
  handleEchoBlock(map) {
    this.echoBlock(map, (node) => {
      // 添加拖动事件
      this.insertEvent(node)

      // 添加右键事件
      this.rightKeyEvent(node)
    })
  }

  /**
   * 回显方块 添加事件
   * @param {node} node 
   */
  insertEvent(node) {
    node.onclick = () => {
      let mark = node.dataset.mark
      
      if(mark == -1) {
        node.dataset.mark = 1
        // 更新视图
        node.querySelector('.click-style').style.display = 'block'
      } else {
        node.dataset.mark = -1
        // 更新视图
        node.querySelector('.click-style').style.display = 'none'
      }
    }
  }
}